export enum FeatureType {
  DataSource = <any> 'DataSource',
  Feature = <any> 'Feature',
  Record = <any> 'Record'
}

export enum FeatureFormat {
  GeoJSON,
  JSON
}

export enum SourceFeatureType {
  Query = <any> 'Query',
  Search = <any> 'Search',
  Click = <any> 'Click',
  LocateXY = <any> 'LocateXY'
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/shared/feature.enum.ts